import { IconAuditTrail, IconPersonCheck, PersonDialog } from '../../../../../components/buttons/IconButtons';
import CustomCard from '../../../../../components/CustomCard';
import DeliveryCard from '../../SubComponents/DeliveryCard';
import ClosedDeliveryCard from './ClosedDeliveryCard';
/**
 * @Email       : sgarcia@ibl.mx
 * @Author      : Susana Garcia Rodriguez
 * @JobTitle    : Frontend
 *
 * Component that displays the Trail information card and handles actions
 * related to the selected activity or item.
 *
 * @param {Object}   item      Data of the trail item to be displayed inside the card.
 * @param {Function} t         Translation function (i18n) used to display text in the selected language.
 * @param {Function} dispatch  Redux dispatch function used to trigger actions related to the trail flow.
 * @param {String}   option    Option or identifier that determines the type of action or view to render.
 */
const TrailCard = ({ item, t, dispatch, option }) => {

    return (
        <CustomCard classCard='card-border-8px' classContent='p-0' classes='mb-2'>
            <div className='d-flex align-items-center m-3'>
                <IconAuditTrail className='h-24px w-24px' />
                <p className='fs-14px font-color-general-950 ibl-font-w-600 ml-2'>{t('trail')}</p>
            </div>

            <div className='border-bottom-shades-300' />

            <div className='ml-3 mb-3'>
                <DeliveryCard
                    item={item}
                    t={t}
                    IconComponent={PersonDialog}
                    iconClass='btn-icon-svg-24px'
                    titleKey='delivery_created_by'
                    dispatch={dispatch}
                    option={option}
                />
            </div>

            {item?.closedById && (
                <div className='ml-3'>
                    <ClosedDeliveryCard
                        item={item}
                        t={t}
                        IconComponent={IconPersonCheck}
                        iconClass='btn-icon-svg-24px'
                        titleKey='delivery_closed_by'
                        dispatch={dispatch}
                        option={option}
                        iconCardClass='background-success-100'
                    />
                </div>
            )}
        </CustomCard>
    );
};

export default TrailCard;
